import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from './notification.service';
import { FatalErrorDialogComponent } from '../components/fatal-error-dialog/fatal-error-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Injectable()
export class ErrorService {

  readonly CONNECTION_MESSAGE = 'error.CONNECTION';
  readonly UNKNOWN_MESSAGE = 'error.UNKNOWN';


  constructor(public _translate: TranslateService,
              public _notification: NotificationService,
              public _dialog: MatDialog) { }

  /**
   * Get an error message from an error straight from an http response
   * @param error The error object
   * @returns
   */
  getMessage(error: any): string {
    // Invalid/Unknown error
    if (!error || !error.error) {
      return this._translate.instant(this.UNKNOWN_MESSAGE);
    }

    // Connection issues
    if (error.statusText && !error.status) {
      return this._translate.instant(this.CONNECTION_MESSAGE);
    }

    return this._translate.instant(`error.${error.error.errorCode}`);
  }

  /**
   * Show a message as an error notification
   * @param error The error to show
   */
  showErrorNotification(error: any) {
    this._notification.error(this.getMessage(error));
  }

  /**
   * Shows the error with the message
   * @param status the http status code
   */
  showErrorWithCode(status: number) {
    if (isNaN(status) || status >= 500) {
      this._notification.errorNotification(`${status}: ${this._translate.instant(`error.UNKNOWN`)}`);
    } else {
      this._notification.errorNotification(`${status}: ${this._translate.instant(`error.${status}`)}`);
    }
  }

  /**
   * Handle a fatal error
   * @param data Data containing information about the error
   */
  fatal(data: any) {
    // Log out
    // this._userService.logout();

    // Open fatal error dialog
    this._dialog.open(FatalErrorDialogComponent, { data });
  }

}
